import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EcertMelding } from '@models';
import { isEmptyValue } from '@helpers';

@Injectable()
export class EcertMeldingService {
  // TODO remove instance, use normal injector!!
  static instance: EcertMeldingService;
  meldingSubject = new Subject<EcertMelding>();
  meldingObservable: Observable<EcertMelding> = this.meldingSubject.asObservable();
  private sluitMeldingSubject = new Subject<string>();
  private getoondeMeldingen = new Set<string>();

  sluitMelding$ = this.sluitMeldingSubject.asObservable();

  constructor() {
    EcertMeldingService.instance = this;
  }

  voegMeldingToe(melding: EcertMelding): boolean {
    if (isEmptyValue(melding)) {
      this.resetGetoondeMeldingen();
      return false;
    }

    const sleutel = this.genereerUniekeSleutel(melding);

    // voorkom dubbele meldingen in het scherm
    if (melding.eenmaligTonen ?? false) {
      if (this.getoondeMeldingen.has(sleutel)) {
        return true;
      }
    }
    melding.id = Date.now() + '-' + Math.random();

    this.getoondeMeldingen.add(sleutel);
    this.meldingSubject.next(melding);

    return true;
  }

  sluitMelding(id: string) {
    this.sluitMeldingSubject.next(id);
  }

  private genereerUniekeSleutel(melding: EcertMelding): string {
    return `${melding.type}|${melding.melding}`;
  }

  resetGetoondeMeldingen(): void {
    this.getoondeMeldingen.clear();
    this.meldingSubject.next(null);
  }
}
